import axios from "axios";

// The eventual production runtime (Buy-Tech.ai FastAPI/PostgreSQL) is reached via
// REACT_APP_BUYAI_API_URL and its /v1 endpoints. Until that is provided we fall
// back to the sandbox FastAPI under REACT_APP_BACKEND_URL/api which mirrors the
// exact contract. Swapping to production is a single env change, no UI changes.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const RUNTIME_URL = process.env.REACT_APP_BUYAI_API_URL || "";

export const API = `${BACKEND_URL}/api`;

// Core sandbox client (auth, projects, preferences, AI, partner leads).
export const api = axios.create({ baseURL: API, withCredentials: true });

// Broker CMA client — points at the real /v1 runtime when configured.
export const brokerBase = RUNTIME_URL ? `${RUNTIME_URL}/v1` : `${API}/broker`;
export const brokerApi = axios.create({ baseURL: brokerBase, withCredentials: true });
export const usingRealRuntime = Boolean(RUNTIME_URL);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
